/* Mobile wallet (MFS) gateways, routing, TDR and bKash agreement helpers.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";

export default {
  methods: {

    //later
    agreementYes() {
      this.agreementStatus = 1;

      var mobile_no = this.others.mobile_number;
      const options = {
        method: "POST",
        url: this.base_url + "bkash-cancel-agreement",
        headers: {
          Authorization: "Bearer " + this.sp_token,
        },
        data: {
          mobile_no,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 1) {
            this.snackbar = true;
            this.color = "success";
            this.timeout = 2000;
            //this.popup_text = "Agreement cancellation successful";
            this.popup_text = "Agreement creation has cancelled";
            this.AgreementPopupDialog = false;
          } else {
            this.AgreementPopupDialog = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //later
    agreementMethod() {
      var mobile_no = this.others.mobile_number;
      const options = {
        method: "POST",
        url: this.base_url + "bkash-agreement-chk",
        headers: {
          Authorization: "Bearer " + this.sp_token,
        },
        data: {
          mobile_no,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 1) {
            this.AgreementPopupDialog = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //no need token
    CloseAgreementPopupDialog() {
      this.agreementStatus = 2;
      this.AgreementPopupDialog = false;
    },

    /**
     * shurcharage/tdr payment action btn
     */

    tdrPayment() {
      var gateway_id = this.mfs_gateway_id_for_tdr;
      var gateway_type_id = this.gateway_type_id_tdr;

      var card_name = this.card_name_tdr;

      if (gateway_type_id == 1) {
        this.goDirectCardsGateWay(card_name);
      }

      if (gateway_type_id == 2) {
        this.goDirectMFSGateWay(gateway_id);
      }

      if (gateway_type_id == 3) {
        this.goDirectIBankingGateway(card_name);
      }
    },

    /**
     * MFS Payment
     * 1)With TDR
     * 2)Without TDR
     */

    tdrComissionInfo(store_id, gateway_id) {
      var sp_token = this.$route.query.token;
      var amount = this.sp_amount;
      const options = {
        method: "POST",
        url: this.base_url + "v1/landing/surcharge",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: { amount, store_id, gateway_id },
      };
      axios
        .request(options)
        .then((response) => {
          var isSurchargeEnable = response.data.isSuccess;

          if (
            isSurchargeEnable === true &&
            response.data.response.isSurcharge === true
          ) {
            this.additional_fees_amt = response.data.response.commSurcharge;
            this.payable_amt = response.data.response.debitAmount;

            this.tdr_visibility = this.is_add_commission;
            this.tdr_visibility_pay_now_btn = this.is_add_commission;
            this.normal_user = 0;
          } else {
            this.tdr_visibility = 0;
            this.tdr_visibility_pay_now_btn = 0;
            this.normal_user = 1;
            this.payable_amt = 0;

            this.goDirectMFSGateWay(gateway_id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    AssignMFSGateway(gateway_id, gateway_type_id) {
        var store_id = this.store_id;
        var is_add_commission_tdr = this.is_add_commission;

        // List of valid gateway IDs for TDR commission
        const validGatewayIds = [14, 16, 21, 22, 24, 23, 25, 46, 52, 53, 54, 55, 56, 57, 65];

        if (is_add_commission_tdr == 1 && validGatewayIds.includes(gateway_id)) {
            this.tdrComissionInfo(store_id, gateway_id, gateway_type_id);
            this.mfs_gateway_id_for_tdr = gateway_id;
            this.gateway_type_id_tdr = gateway_type_id;
        } else {
            // No commission, go direct
            this.goDirectMFSGateWay(gateway_id);
        }
    },

    goDirectMFSGateWay(gateway_id) {
    console.log(gateway_id);

      // Mapping gateway_id to corresponding method calls
      const gatewayActions = {
          14: this.ROCKET,
          16: this.MCASH,
          21: this.NAGAD,
          22: this.BKASH,
          46: this.TCASH,
          24: this.OKWALLET,
          23: this.UPAY,
          25: this.SHURECASH,
          52: () => { console.log("rocket two"); this.ROCKETTWO(); },
          53: this.ISLAMICWALLET,
          54: this.POCKET,
          55: this.PATHAOPAYWALLET,
          56: this.MEGHNABANKWALLET,
          57: this.CELLFINWALLET,
          65: this.SHAMADHAN,

      };

      // Check if gateway_id exists in the mapping, then execute the function
      if (gatewayActions[gateway_id]) {
          gatewayActions[gateway_id].call(this);
      }
},


    go_mfs_gateway(gateway_id, gateway_type_id) {
      this.mfs_selected_gateway_iddd = gateway_id;
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.AssignMFSGateway(gateway_id, gateway_type_id);
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    //later
    bkash_num_list() {
      var sp_token = this.$route.query.token;
      var mobile_no = localStorage.getItem("mobile_no");
      const options = {
        method: "POST",
        url: this.base_url + "bkash-mobile-list",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: {
          mobile_no,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 2) {
            this.hasNumSaved = false;
          } else {
            this.saved_bkash = response.data;
            this.hasNumSaved = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //checked when clicked
    BKASH() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "bkash-pay-now",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amount,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.parent.postMessage("linkClicked:" + response.data.burl, "*");
            window.location.href = response.data.burl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //no need
    closePopup() {
      this.popup_dialog = false;
      this.$refs.form3.reset();
    },

    //checked when clicked
    send_bkh() {
      let checkVal = this.$refs.form3.validate();
      var agreement_cancle = this.agreementStatus;

      if (checkVal) {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;

        var payable_amount2 = this.payable_amt;
        var amount;

        if (payable_amount2 > 0) {
          amount = payable_amount2;
        } else {
          amount = this.sp_amount;
        }
        var mobile_no = this.others.mobile_number;
        var mobile_number = localStorage.getItem("mobile_no");
        var bankPara = "bkh";
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;

        if (mobile_number === null) {
          const options = {
            method: "POST",
            url: this.base_url + "bkash-pay-now",
            headers: {
              Authorization: "Bearer " + this.sp_token,
            },
            data: {
              orderid,
              amount,
              bankPara,
              mobile_no,
              store_id,
              invoiceno,
              agreement_cancle,
            },
          };
          axios
            .request(options)
            .then((response) => {
              window.location.href = response.data.burl;
              this.$refs.form3.reset();
              this.popup_dialog = false;
              this.loading_tab = false;
              this.loading_dialog = false;
            })
            .catch((error) => {
              console.log(error);
              this.$refs.form3.reset();
              this.popup_dialog = false;
              this.loading_tab = false;
              this.loading_dialog = false;
            });
        }

        if (mobile_number !== null) {
          const options = {
            method: "POST",
            url: this.base_url + "bkash-pay-now",
            headers: {
              Authorization: "Bearer " + this.sp_token,
            },
            data: {
              orderid,
              amount,
              bankPara,
              mobile_no,
              mobile_number,
              store_id,
              invoiceno,
              agreement_cancle,
            },
          };
          axios
            .request(options)
            .then((response) => {
              window.location.href = response.data.burl;
              this.$refs.form3.reset();
              this.popup_dialog = false;
              this.loading_tab = false;
              this.loading_dialog = false;
            })
            .catch((error) => {
              console.log(error);
              this.$refs.form3.reset();
              this.popup_dialog = false;
              this.loading_tab = false;
              this.loading_dialog = false;
            });
        }
      }
    },

    //checked when clicked
    NAGAD() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "nagad-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.parent.postMessage("linkClicked:" + response.data.nurl, "*");
            window.location.href = response.data.nurl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    MCASH() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;

        const options = {
          method: "POST",
          url: this.base_url + "mcash-pay-amt",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            amt,
            orderid,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.location.href = response.data.mburl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    TCASH() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "tap/generate-initiate-payment-url",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            amount,
            orderid,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.status == true) {
              this.loading_tab = false;
              this.loading_dialog = false;
              window.location.href = response.data.tap_url;
            } else if (response.data.status == false) {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 4000;
              this.popup_text = response.data.message;
              this.loading_tab = false;
              this.loading_dialog = false;
            } else {
              this.loading_tab = false;
              this.loading_dialog = false;
              this.snackbar = true;
              this.color = "red";
              this.timeout = 3000;
              this.popup_text = "Something went wrong.";
            }
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    UPAY() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;

        var bankPara = "upay";
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "upay-payment",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amount,
            bankPara,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.location.href = response.data.upurl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    SHURECASH() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var bankPara = "scash";
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;

        const options = {
          method: "POST",
          url: this.base_url + "sure-cash-amt",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amount,
            bankPara,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.location.href = response.data.scurl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    OKWALLET() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var bankPara = "ok-wallet";
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "ok-wallet-amt",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amount,
            bankPara,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.location.href = response.data.ourl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    ROCKET() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 10) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 10 Taka.";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var store_id = this.store_id;
        var card_name = "rocket";
        var invoiceno = this.invoiceno;

        const options = {
          method: "POST",
          url: this.base_url + "only-card-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            store_id,
            card_name,
            amount,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.message == 1) {
              this.loading_tab = false;
              this.loading_dialog = false;
              window.location.href = response.data.url;
              } else if (response.data.message == 5) {
                document.open();
                document.write(response.data.url);         // HTML display
                document.close();
              } else {
              this.loading_tab = false;
              this.loading_dialog = false;
              this.snackbar = true;
              this.color = "red";
              this.timeout = 3000;
              this.popup_text = "Something went wrong.";
            }
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            console.log(error);
          });
      }
    },

    ROCKETTWO() {
      var payable_amount2 = this.payable_amt;
      var amount;

      if (payable_amount2 > 0) {
        amount = payable_amount2;
      } else {
        amount = this.sp_amount;
      }

      if (amount < 10) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 10 Taka.";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var store_id = this.store_id;
        var card_name = "dbbl-two-rocket";
        var invoiceno = this.invoiceno;

        const options = {
          method: "POST",
          url: this.base_url + "only-card-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            store_id,
            card_name,
            amount,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.message == 1) {
              this.loading_tab = false;
              this.loading_dialog = false;
              window.parent.postMessage(
                "linkClicked:" + response.data.burl,
                "*"
              );
              window.location.href = response.data.url;
              } else if (response.data.message == 5) {
                document.open();
                document.write(response.data.url);         // HTML display
                document.close();
              } else {
              this.loading_tab = false;
              this.loading_dialog = false;
              this.snackbar = true;
              this.color = "red";
              this.timeout = 3000;
              this.popup_text = "Something went wrong.";
            }
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            console.log(error);
          });
      }
    },

    ISLAMICWALLET() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "islamic-wallet-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.parent.postMessage(
              "linkClicked:" + response.data.iwurl,
              "*"
            );
            window.location.href = response.data.iwurl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    POCKET() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "pocket-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.parent.postMessage("linkClicked:" + response.data.purl, "*");
            window.location.href = response.data.purl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    PATHAOPAYWALLET() {
      console.log("ok");
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "pathao-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            // window.parent.postMessage("linkClicked:" +  response.data.purl  , "*");
            window.location.href = response.data.url;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    SHAMADHAN() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "shamadhan-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            window.location.href = response.data.url;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    MEGHNABANKWALLET() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "meghna-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            // window.parent.postMessage("linkClicked:" +  response.data.purl  , "*");
            window.location.href = response.data.url;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    CELLFINWALLET() {
      var payable_amount2 = this.payable_amt;
      var amt;

      if (payable_amount2 > 0) {
        amt = payable_amount2;
      } else {
        amt = this.sp_amount;
      }

      if (amt < 1) {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 3000;
        this.popup_text = "Amount Cannot be less than 1 Taka";
      } else {
        this.loading_tab = true;
        this.loading_dialog = true;
        var orderid = this.$route.query.order_id;
        var invoiceno = this.invoiceno;
        var store_id = this.store_id;
        const options = {
          method: "POST",
          url: this.base_url + "cellfin-pay",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
          data: {
            orderid,
            amt,
            store_id,
            invoiceno,
          },
        };
        axios
          .request(options)
          .then((response) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            // window.parent.postMessage("linkClicked:" +  response.data.redirectUrl  , "*");
            window.location.href = response.data.redirectUrl;
          })
          .catch((error) => {
            this.loading_tab = false;
            this.loading_dialog = false;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = "Something went wrong.";
            console.log(error);
          });
      }
    },

    //checked when clicked
    show_mbanking() {
      this.card_tab = false;
      this.mobile_banking = true;
      this.i_banking = false;
      this.user_account = false;
      this.loading_tab = false;
      this.loading_dialog = false;
      this.saved_card_tab1 = false;
      var passStoreID = this.store_id;

      this.tdr_visibility = 0;
      this.tdr_visibility_pay_now_btn = 0;
      this.normal_user = 1;
      this.payable_amt = 0;

      this.cof_pay_now_btn_label = "Pay Now";
      this.saved_card_paynow_label = "Pay Now";
      this.isFormValid2 = false;
      this.selectedCvvIndex = null;

      this.merchant_gateway(2);

      this.cards_selected_gateway_iddd = 0;
      this.mfs_selected_gateway_iddd = 0;
      this.ibanking_selected_gateway_iddd = 0;
      this.saved_card_list = false;
      this.deleteCardConfirmationDialog = false;
      this.deleteConfirmationCard = false;
      this.cardSkeletonLoader = false;
      this.AccountActiveDeactiveDiv = false;
    },

    //no need
    transfer_number(selected_number) {
      this.others.mobile_number = selected_number;
      document.getElementById("bks").focus();
    },

    //later
    delete_bks_num(delete_num, index) {
      //console.log(delete_num);
      //console.log(index);
      //this.saved_bkash.splice(index, 1);
      var sp_token = this.$route.query.token;
      var mobile_no = delete_num;
      const options = {
        method: "POST",
        url: this.base_url + "bkash-cancel-agreement",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: {
          mobile_no,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 1) {
            this.saved_bkash.splice(index, 1);
            // this.popup_dialog =false;
            // this.loading_tab=false;
            // this.loading_dialog=false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
